import { List, Record } from 'immutable';

export type IRecordClassOf<T extends object> = Record.Factory<T>;
export type IRecordOf<T extends object> = Record<T> & Readonly<T>;

export const RecordOf = Record;
export const EmptyListOf = <T extends object>(record: IRecordClassOf<T>) => List<IRecordOf<T>>();

export const findById = <D extends { id }>(list: List<D>, id) => list.find((d) => d.id === id);
export const mergeListsById = (a, b) => a.filter((ar) => !b.find((br) => br.id === ar.id)).concat(b);
